"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlTrace2dNaturalLogTransformComponent = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@visualization-tools/core");
const rc_js_util_1 = require("rc-js-util");
const gl_cartesian_2d_trace_binder_1 = require("../../axis/traces/gl-cartesian-2d-trace-binder");
const point2d_natural_log_transform_shader_1 = require("./point2d-natural-log-transform-shader");
const cartesian2d_natural_log_transform_1 = require("./cartesian2d-natural-log-transform");
/**
 * @public
 * Applies natural log to a trace gl connector. The behavior of the transform is undefined if the range is less than 0.
 */
class GlTrace2dNaturalLogTransformComponent {
    constructor(traceBinder) {
        this.traceBinder = traceBinder;
        this.config = new rc_js_util_1.Vec2.f32();
        this.bindings = {
            feedbackTransform: new core_1.GlTransformFeedback(),
            configUniform: new core_1.GlVec2Uniform("traceNaturalLogTransform_config", this.config),
        };
        this.specification = core_1.GlProgramSpecification.mergeProgramSpecifications([
            this.traceBinder.specification,
            new core_1.GlProgramSpecification(core_1.GlShader.combineShaders([
                point2d_natural_log_transform_shader_1.point2dNaturalLogTransformShader,
                vertexShader,
            ]), core_1.dummyGlProgramSpecification.fragmentShader),
        ]);
    }
    getCacheId() {
        return [
            "trace2dLogTransform",
            this.traceBinder.getTransformId(),
        ].join("_");
    }
    initialize(transformRenderer) {
        this.traceBinder.initialize(transformRenderer);
        this.bindings.feedbackTransform.initialize(transformRenderer);
        this.bindings.configUniform.initialize(transformRenderer);
    }
    resetState() {
        this.traceBinder.resetState();
    }
    setOutputBuffers(entity, binder, transformRenderer) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.traceBinder.binderClassificationId === binder.binderClassificationId, "attempted to transform inappropriate binder");
        this.bindings.feedbackTransform.bind(transformRenderer);
        this.traceBinder.setResultBuffers(entity, binder, transformRenderer, transformRenderer.context.STREAM_DRAW);
    }
    performTransform(entity, transformRenderer, updateArg) {
        this.config[0] = Number(updateArg.userTransform.xTransformEnabled);
        this.config[1] = Number(updateArg.userTransform.yTransformEnabled);
        this.bindings.configUniform.setData(this.config, transformRenderer.sharedState.frameCounter);
        this.bindings.configUniform.bind(transformRenderer);
        this.traceBinder.update(entity, transformRenderer);
        this.bindings.feedbackTransform.beginTransform(transformRenderer);
        transformRenderer.context.drawArrays(transformRenderer.context.POINTS, 0, entity.data.getTraceCount());
        this.bindings.feedbackTransform.endTransform(transformRenderer);
        this.traceBinder.clearResultBuffers(transformRenderer);
    }
}
GlTrace2dNaturalLogTransformComponent.factory = new core_1.GlTransformComponentFactory(cartesian2d_natural_log_transform_1.Cartesian2dNaturalLogTransform.transformId, gl_cartesian_2d_trace_binder_1.TraceBinderIdentifier, GlTrace2dNaturalLogTransformComponent);
(0, tslib_1.__decorate)([
    rc_js_util_1.Once
], GlTrace2dNaturalLogTransformComponent.prototype, "getCacheId", null);
exports.GlTrace2dNaturalLogTransformComponent = GlTrace2dNaturalLogTransformComponent;
// @formatter:off
// language=GLSL prefix="#if __VERSION__ >=300 && __VERSION__ < 400 \n #define ATTRIBUTE in \n #define VARYING out \n #else \n #define ATTRIBUTE attribute \n #define VARYING varying \n #endif"
const vertexShader = new core_1.GlShader(`
uniform vec2 traceNaturalLogTransform_config;

void main()
{
    mat2 position = traceConnector_getPosition();
    vec2 lowerPoint = point2dNaturalLogTransform(position[0], traceNaturalLogTransform_config);
    vec2 upperPoint = point2dNaturalLogTransform(position[1], traceNaturalLogTransform_config);

    traceConnector_setPosition(lowerPoint, upperPoint);
}
`, 300);
// @formatter:on
//# sourceMappingURL=gl-trace2d-natural-log-transform-component.js.map